import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { TruckCard } from "../components/TruckCard";
import { TruckGridSkeleton } from "../components/TruckCardSkeleton";
import { Button } from "../components/ui/button";

export default function Alerts() {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const [trucks, setTrucks] = useState([]);
  const [busy, setBusy] = useState(true);

  useEffect(() => { if (!loading && !user) nav("/connexion"); }, [user, loading, nav]);
  useEffect(() => {
    if (!user) return;
    api.get("/me/subscriptions").then((r) => setTrucks(r.data.results)).finally(() => setBusy(false));
  }, [user]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="text-3xl sm:text-4xl font-display font-extrabold text-urban-teal flex items-center gap-2"><Bell className="text-fresh-mint" /> Mes alertes</h1>
      <p className="text-urban-teal/60 mt-1">Les foodtrucks que vous suivez. Vous êtes prévenu par e-mail à chaque changement d'emplacement.</p>

      {busy ? (
        <TruckGridSkeleton count={4} />
      ) : trucks.length === 0 ? (
        <div className="text-center py-16" data-testid="alerts-empty">
          <Bell size={48} className="text-urban-teal/20 mx-auto" />
          <p className="font-display font-bold text-xl text-urban-teal mt-4">Aucune alerte active</p>
          <p className="text-urban-teal/60 mt-2">Abonnez-vous à un foodtruck depuis sa fiche pour être prévenu.</p>
          <Button asChild className="rounded-full bg-street-gold text-white font-bold mt-5"><Link to="/recherche">Explorer les foodtrucks</Link></Button>
        </div>
      ) : (
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4 mt-6">
          {trucks.map((t, i) => <TruckCard key={t.slug} truck={t} index={i} />)}
        </div>
      )}
    </div>
  );
}
